import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  PLATFORM_ID,
  inject,
  ViewChild,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Event, EventsService } from '../../core/services/events.service';
import { MetaService } from '../../core/services/meta.service';
import { WebAppConfigService } from '../../core/services/webapp-config.service';
import { Header } from '../../components/header/header';
import { Footer } from '../../components/footer/footer';
import { ScrollToTop } from '../../components/scroll-to-top/scroll-to-top';
import { TicketSelectorTren } from '../../components/ticket-selector-tren/ticket-selector-tren';
import { TicketsService, TipoTicketDetailed } from '../../core/services/tickets.service';

@Component({
  selector: 'app-comprarlocalidad',
  standalone: true,
  imports: [CommonModule, Header, Footer, ScrollToTop, TicketSelectorTren],
  templateUrl: './comprarlocalidad.html',
  styleUrl: './comprarlocalidad.css',
})
export class ComprarLocalidadPage implements OnInit, OnDestroy {
  @ViewChild(Header) header?: Header;

  event?: Event;
  tipoticket?: TipoTicketDetailed;
  tipoticketid = '';
  isLoading = true;
  error = false;
  isExpired = false;
  expirationMessage = '';

  private platformId = inject(PLATFORM_ID);
  private isBrowser: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private eventsService: EventsService,
    private ticketsService: TicketsService,
    private metaService: MetaService,
    private webAppConfig: WebAppConfigService,
    private cdr: ChangeDetectorRef
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    const config = this.webAppConfig.config();
    if (config) {
      this.metaService.resetToDefault(
        this.webAppConfig.getSiteName() + ' - ' + config.short_description,
        config.description,
        config.url_logo,
        config.url
      );
    }

    this.route.params.subscribe((params) => {
      const urlSlug = params['url_slug'];
      this.tipoticketid = params['tipoticketid'] || '';

      if (urlSlug && this.tipoticketid) {
        this.loadData(urlSlug, this.tipoticketid);
      } else {
        this.router.navigate(['/']);
      }
    });
  }

  ngOnDestroy(): void {
    const config = this.webAppConfig.config();
    if (config) {
      this.metaService.resetToDefault(
        this.webAppConfig.getSiteName() + ' - ' + config.short_description,
        config.description,
        config.url_logo,
        config.url
      );
    }
  }

  private loadData(urlSlug: string, tipoticketid: string): void {
    this.isLoading = true;
    this.error = false;

    this.eventsService.getEventBySlug(urlSlug).subscribe({
      next: (eventRes) => {
        if (!eventRes.success || !eventRes.data) {
          this.error = true;
          this.isLoading = false;
          this.cdr.markForCheck();
          return;
        }

        this.event = eventRes.data;

        this.ticketsService.getTipoTicketByIdForWeb(tipoticketid).subscribe({
          next: (ttRes) => {
            if (!ttRes.success || !ttRes.data) {
              this.router.navigateByUrl('/404');
              return;
            }

            this.tipoticket = ttRes.data;

            if (this.tipoticket.eventoid !== this.event!.eventoid) {
              this.error = true;
              this.isLoading = false;
              this.cdr.markForCheck();
              return;
            }

            this.checkAvailability();
            this.isLoading = false;
            this.cdr.markForCheck();
          },
          error: () => {
            this.router.navigateByUrl('/404');
          }
        });
      },
      error: () => {
        this.error = true;
        this.isLoading = false;
        this.cdr.markForCheck();
      }
    });
  }

  private checkAvailability(): void {
    if (!this.tipoticket?.funcion?.fecha_funcion_maxima_disponible_web) {
      return;
    }

    const fechaMaximaUTC = new Date(this.tipoticket.funcion.fecha_funcion_maxima_disponible_web);
    const fechaActual = new Date();

    if (fechaActual > fechaMaximaUTC) {
      this.isExpired = true;
      this.expirationMessage = `La venta web para esta localidad cerró el ${fechaMaximaUTC.toLocaleString('es-ES', {
        dateStyle: 'full',
        timeStyle: 'short',
      })}.`;
    }
  }

  onTicketsAdded(): void {
    if (this.header) {
      this.header.loadCartCount();
    }
  }

  goBackToEvent(): void {
    if (this.event) {
      this.router.navigate(['/evento', this.event.url_slug]);
    } else {
      this.router.navigate(['/']);
    }
  }

  getBannerImage(): string {
    if (this.event?.imagenes?.horizontal) return this.event.imagenes.horizontal;
    return 'https://dummyimage.com/2000x576/cccccc/666666?text=Comprar+Localidad';
  }

  formatFechaHora(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  }
}
